import { ATHENA_PORTAL } from "~/screens/Hub/shared/sharedUrls";
import { Button } from "~/shared";
import { customIcons, icons } from "~/ui";
import athenaLogo from "../assets/athena.png";
import { Card } from "./Card";
import { UpcomingVisitsCard } from "./UpcomingVisitsCard";

const patientPortalItems = [
  "Message your care team",
  "Pay your copay or out-of-pocket invoices",
  "Update your pharmacy",
];

export const PortalCards = () => {
  return (
    <section className="mb-12 grid grid-cols-1 gap-7 md:grid-cols-5">
      <UpcomingVisitsCard className="md:col-span-3" />

      <Card
        className="space-y-5 md:col-span-2 md:self-start"
        title="Secure patient portal"
      >
        <ul className="space-y-1 text-gray-700">
          {patientPortalItems.map((item) => (
            <li key={item} className="flex items-center gap-2 text-gray-600">
              <span className="border-success bg-success inline-flex size-5 shrink-0 items-center justify-center rounded-full border">
                <icons.outline.CheckIcon className="stroke-3 size-3 shrink-0 text-white" />
              </span>
              <p className="font-sans text-neutral-700">{item}</p>
            </li>
          ))}
        </ul>

        <Button className="px-8 py-2 font-medium" variant="outline-hub" asChild>
          <a href={ATHENA_PORTAL} target="_blank" rel="noopener noreferrer">
            Go to my portal
            <customIcons.ArrowUpRightIcon className="text-violet ml-2 size-5" />
          </a>
        </Button>

        <p className="w-full text-center italic leading-5 text-gray-500">
          Note: You'll need to create a unique login for the patient portal.
        </p>
        <div className="flex items-center justify-center gap-1 text-gray-500">
          Powered by{" "}
          <img
            className="w-32 pb-1"
            src={athenaLogo}
            alt="Athena Health Logo"
          />
        </div>
      </Card>
    </section>
  );
};
